import { render, staticRenderFns } from "./contact-service.vue?vue&type=template&id=b9d5c198&scoped=true&"
import script from "./contact-service.vue?vue&type=script&lang=js&"
export * from "./contact-service.vue?vue&type=script&lang=js&"
import style0 from "./contact-service.vue?vue&type=style&index=0&id=b9d5c198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d5c198",
  null
  
)

export default component.exports